module.exports = __webpack_public_path__ + "img/2-5-who-gameplan.77e4ec83.jpg";